import styled from "@emotion/styled";

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  padding: 1rem;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
`;

export const ModalContentText = styled.p`
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0 1rem;
`;
